import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { billingShiftDifferentialModStyles } from './BillingShiftDifferentialMod.style';
import {
  selectCurrentModDetails,
  selectExpandedModsDialog,
  selectIsEditExistingMod,
  selectIsEditMod,
  selectShiftDifferentialDescriptionTypes,
  selectShiftDifferentialTemplateTypes,
  selectShiftDifferentialTypes,
} from 'store/redux-store/placement-mods/selectors';
import { BillingShiftDiffGrid } from './BillingShiftDiffGrid';
import { Template } from '../../CommonComponents/Template';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { getFormattedBillingShiftDifferential } from '../../ModificationsUtils';

export const BillingShiftDifferentialMod = () => {
  const selectedModsDetails = useSelector(selectCurrentModDetails);
  const isModEdit = useSelector(selectIsEditMod);
  const { classes } = billingShiftDifferentialModStyles({ isModEdit });
  const shiftDifferentialTemplateTypes = useSelector(selectShiftDifferentialTemplateTypes);
  const dispatch = useDispatch();
  const isEditExistingMod = useSelector(selectIsEditExistingMod);
  const shiftDifferentialTypes = useSelector(selectShiftDifferentialTypes);
  const shiftDifferentialDescriptionTypes = useSelector(selectShiftDifferentialDescriptionTypes);
  const isExpanded = useSelector(selectExpandedModsDialog);
  const [isTemplateChanged, setTemplateChanged] = useState(false);

  useEffect(() => {
    if (selectedModsDetails?.shiftDifferentials && (isModEdit || isEditExistingMod)) {
      dispatch(
        placementModsAction.setEditBillingShiftDiffRows(
          getFormattedBillingShiftDifferential(
            selectedModsDetails?.shiftDifferentials,
            shiftDifferentialTypes,
            shiftDifferentialDescriptionTypes,
            isModEdit,
          ),
        ),
      );
    }
  }, [selectedModsDetails.shiftDifferentials, isModEdit]);

  return (
    <Grid>
      <Grid className={classes.gridRow}>
        <Template
          isExpanded={isExpanded}
          isModEdit={isModEdit}
          options={shiftDifferentialTemplateTypes}
          setTemplateChanged={setTemplateChanged}
        />
      </Grid>
      <Grid className={classes.gridRow}>
        <BillingShiftDiffGrid
          billingShiftDiffRequests={selectedModsDetails.shiftDifferentials}
          isTemplateChanged={isTemplateChanged}
          setTemplateChanged={setTemplateChanged}
        />
      </Grid>
    </Grid>
  );
};
